import { Heart } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./Footer.module.css";

export function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <nav className={styles.links} aria-label={t("footer.navLabel")}>
          <Link to="/how-it-works">{t("footer.howItWorks")}</Link>
          <Link to="/usefor">{t("useCases.footerLink")}</Link>
          <Link to="/faq">{t("footer.faq")}</Link>
          <Link to="/for-ai-agents">{t("footer.agents")}</Link>
          <Link to="/press">{t("footer.press")}</Link>
          <Link to="/privacy">{t("footer.privacy")}</Link>
          <Link to="/imprint">{t("footer.imprint")}</Link>
        </nav>
        <p className={styles.meta}>
          <span>&copy; {year} brings-mit.com</span>
          <span className={styles.madeIn}>
            <Heart size={12} weight="fill" /> {t("footer.madeIn")}
          </span>
        </p>
      </div>
    </footer>
  );
}
